import { render, staticRenderFns } from "./ModalAdminPopUp.vue?vue&type=template&id=3ed543d0&"
import script from "./ModalAdminPopUp.vue?vue&type=script&lang=js&"
export * from "./ModalAdminPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports